namespace advisorop.components.advisor {
    
    export class HhReallocationController {
        //bindings
        $router;

        showUserEntry: boolean = true;
        //dropdown with HH
        selHousehold: domains.IHousehold;
        households: domains.IHousehold[];

        //investment types
        investmentTypes: domains.ILOV[];
        productTypes: domains.ILOV[];
        
        //current household
        householdId: number;  //if =0 then households will be loaded and dropdown with households will be shown
        household: domains.IHousehold;
        householdRtgs: domains.IAccountGroup[];
        hhrModel: domains.IHhrMain = {}; //household accounts
        insuranceAccounts = [];
        AccountStatus = domains.AccountStatus;

        newAccount: domains.IAccount = { id: 0 };
        hhrModelOrginal: domains.IHhrMain = {}; //household accounts

        static $inject = ["generalService", "accountGeneralService", "advisorService", "advisorHhrService", "accountApi", "advisoryFirmApi"];
        constructor(private generalService: services.GeneralService,
            private accountGeneralService: services.AccountGeneralService,
            private advisorService: services.AdvisorService,
            private advisorHhrService: services.AdvisorHhrService,
            private accountApi: services.AccountApi,
            private advisoryFirmApi: services.AdvisoryFirmApi) {
        }

        onSelectHousehold(item, model, label, event): void {
            this.loadHousehold(this.selHousehold ? this.selHousehold.id : 0);
        };

        loadHouseholds() {
            this.advisorService.getHouseholds(false,false)
                .then(response => {
                    this.households = response.data;
                }, err => this.generalService.showError(err));
        }

        loadRtgs(householdId: number) {
            this.advisorService.getRTGByHousehold(householdId).then(response => {
                this.householdRtgs = response.data;
                // console.log("Household RTGs has been loaded: ", this.householdRtgs);
            }, err => this.generalService.showError(err))
        }

        refreshHhrAccount = (ac: domains.IHhrAccount) => {
            if (ac.investmentType)
                ac.selInvestmentType = <domains.ILOV>{ value: ac.investmentType, name: ac.investmentTypeDescription };
            // rtg
            if (ac.rtgId && ac.rtgId > 0) {
                ac.selRtg = <domains.IAccountGroup>{
                    id: ac.proposedRtgId,
                    householdId: this.householdId,
                    accountGroupDescription: ac.proposedRtgDescription,
                    description: ac.proposedRtgDescription,
                    groupName: ac.proposedRtgDescription
                }
            }

            //tamp
            if (this.hasTamp(ac)) {
                this.loadTamps(ac);
                if (ac.tampId) {
                    ac.selTamp = <domains.ITamp>{
                        id: ac.tampId,
                        name: ac.tampName
                    };
                };
            }
            if (ac.productType)
                ac.selProductType = <domains.ILOV>{ value: ac.productType, name: ac.productTypeDescription };
            //managers
            if (this.hasManager(ac)) {
                this.loadManagers(ac);
                if (ac.managerId) {
                    ac.selManager = <domains.IManager>{
                        id: ac.managerId,
                        name: ac.managerName
                    };
                };
            }

            //products
            if (this.hasProduct(ac)) {
                this.loadProducts(ac);
                if (ac.productId) {
                    ac.selProduct = <domains.IManagerProduct>{
                        id: ac.productId,
                        name: ac.productName
                    };
                };
            }
        }

        refreshHhrTitle = (tit: domains.IHhrTitle) => {
            for (var a = 0; a < tit.accounts.length; a++) {
                this.refreshHhrAccount(tit.accounts[a]);
            }
        } 

        refreshHouseholdGird = () => {
            for (var g = 0; g < this.hhrModel.groups.length; g++) {
                for (var t = 0; t < this.hhrModel.groups[g].titles.length; t++) {
                    var tit = this.hhrModel.groups[g].titles[t];
                    this.refreshHhrTitle(tit);
                }
            }
        }

        loadHousehold(householdId?: number): void {
            //
            if (!householdId) {
                this.householdId = null;
                this.hhrModel = null;
                this.hhrModelOrginal = null;
                return;
            }

            this.householdId = householdId;

            this.loadRtgs(this.householdId);
            
            this.advisorService.getHousehold(householdId)
                .then(response => this.household = response.data, err => this.generalService.showError(err));

            var lovs: domains.ILOV[];

            this.advisorHhrService.getHhrAccounts(householdId, false, true)
                .then(response => {
                    //console.log('HHR loaded: ', response.data);
                    this.hhrModel = response.data;
                    //add lovs
                    this.refreshHouseholdGird();
                }, err => this.generalService.showError(err));

            this.loadHhrOriginal();
        }

        loadHhrOriginal = () => {
            this.advisorHhrService.getHhrAccounts(this.householdId, true, false)
                .then(response => this.hhrModelOrginal = response.data, err => this.generalService.showError(err));
        }

        loadTamps(ac: domains.IHhrAccount): ng.IPromise<domains.ITamp[]> {
            return this.advisoryFirmApi.getTamps(ac.advisoryFirmId)
                .then(response => {
                    ac.tamps = response.data;
                    // by default first TAMP is selected - PERSHING
                    if (!ac.selTamp && ac.tamps.length > 0) {
                        ac.selTamp = ac.tamps[0];
                    }
                    return response.data;
                }, err => toastr.error("Cannot load TAMPs. " + err.data));
        };

        loadManagers(ac: domains.IHhrAccount): ng.IPromise<any> {
            //console.log(`Load managers called`, ac);
            if (ac.selProductType && ac.selInvestmentType) {
                // outside investment account should show global Managers and Products for selected product type and manager
                if (ac.selInvestmentType.value == domains.InvestmentType.OUTSIDE_INVESTMENT) {
                    return this.advisorService.getAllManagers(ac.selProductType.value)
                        .then(response => {
                            ac.managers = response.data;
                        }, err => toastr.error("Managers has not been loaded..."));
                }
                else if (ac.selInvestmentType.value == domains.InvestmentType.DIRECT_INVESTMENT) {
                    return this.advisorService.getManagers(this.household.advisoryFirmId, ac.selProductType.value)
                        .then(response => {
                            ac.managers = response.data;
                        }, err => toastr.error("Managers has not been loaded..."));
                }
            }
            // else reset manager list
            ac.selManager = null;
            ac.managers = [];
        };

        loadProducts(ac: domains.IHhrAccount): ng.IPromise<any> {
            //console.log("loading products...");
            if (ac.selManager && ac.selProductType) {
                // outside investment account should show global Managers and Products for selected product type and manager
                if (ac.selInvestmentType.value == domains.InvestmentType.OUTSIDE_INVESTMENT) {
                    return this.advisorService.getProductsByManager(ac.selProductType.value, ac.selManager.id)
                        .then(response => ac.products = response.data, err => toastr.error("Products has not been loaded..."));
                }
                // direct investment account should show advisory firm Managers and Products for selected product type and manager
                else if (ac.selInvestmentType.value == domains.InvestmentType.DIRECT_INVESTMENT) {
                    return this.advisorService
                        .getProductsByFirm(this.household.advisoryFirmId, ac.selProductType.value, ac.selManager.id, domains.InvestmentType.DIRECT_INVESTMENT)
                        .then(response => ac.products = response.data, err => toastr.error("Products has not been loaded..."));
                }
            }

            // else reset product list
            ac.selProduct = null;
            ac.products = [];
        }

        //event when investment type change
        //maybe we need to load managers or products
        investmentTypeChange = (ac: domains.IHhrAccount): void => {
            if (this.hasManager(ac)) {
                this.loadManagers(ac);
            }

            if (this.hasTamp(ac)) {
                this.loadTamps(ac);
            }
        }

        managerChange = (ac: domains.IHhrAccount): void => {
            //console.log("managerChange has been called");
            if (this.hasProduct(ac)) {
                this.loadProducts(ac);
            }
        }

        //event when tamp is changed
        tampChange = (ac: domains.IHhrAccount): void => {
            //console.log("tampChange has been called");
        }

        //event when product type change
        //maybe we need to reload managers or products
        productTypeChange = (ac: domains.IHhrAccount): void => {
            if (this.hasManager(ac) === 1) {
                this.loadManagers(ac);
            }
        }

        addNewAccount = (title: domains.IHhrTitle): void => {
            toastr.info("addNewAccount called");
            var ac: domains.IHhrAccount = {
                id: 0,
                accountId: null,
                accountName: "New account",
                advisoryFirmId: this.household.advisoryFirmId,
                balance: 0,
                change: 0,
                status: domains.AccountStatus.SETUP,
                statusDescription: "Setup",
                investors: [], // take it from Title on server side ... ???
                original: {}
            };


            title.accounts.push(ac);
        }

        addNewTitleInvestor = (): void => {
            this.openNewTitlePopup();
        }

        increaseBalance = (amount: number, group: domains.IHhrGroup, title: domains.IHhrTitle) => {
            group.change = group.change + amount;
            title.change = title.change + amount;
            this.hhrModel.change = this.hhrModel.change + amount;

            group.balance = group.balance + amount;
            title.balance = title.balance + amount;
            this.hhrModel.balance = this.hhrModel.balance + amount;
        }

        onBalanceChanged = (ac: domains.IHhrAccount, group: domains.IHhrGroup, title: domains.IHhrTitle): void => {
            const diff_change = ac.balance - ac.original.balance - ac.change;
            this.increaseBalance(diff_change, group, title);
            ac.change = ac.balance - ac.original.balance;

            // issue with saving hhr
            if (!ac.change) {
                ac.change = 0;
            }
        }

        resetAccount = (ac: domains.IHhrAccount, group: domains.IHhrGroup, title: domains.IHhrTitle): void => {
            if (!(ac.original && ac.original.accountId > 0)) {
                toastr.error("This is new account so it cannot be reset");
                return;
            }

            if (confirm("You are going to reset account to original values. Are you sure ?")) {
                this.increaseBalance(-ac.change, group, title);
                ac.balance = ac.original.balance;
                ac.change = 0;
                
                //ac.investmentType = ac.original.investmentType;
                //ac.investmentTypeDescription = ac.original.investmentTypeDescription;

                //// tamp
                //ac.tampId = ac.original.tampId;
                //ac.tampName = ac.original.tampName;

                //// product type
                //ac.productType = ac.original.productType;
                //ac.productTypeDescription = ac.original.productTypeDescription;
                
                //// manager
                //ac.managerId = ac.original.managerId;
                //ac.managerName = ac.original.managerName;
                //ac.company = ac.original.company;
                
                //// product
                //ac.productId = ac.original.productId;
                //ac.productName = ac.original.productName;

                // RTG
                ac.rtgId = ac.original.rtgId;
                ac.rtgDescription = ac.original.rtgDescription;
                ac.proposedRtgId = ac.original.rtgId;
                ac.proposedRtgDescription = ac.original.rtgDescription;

                // this.refreshHhrAccount(ac);
            }
            
        }

        deleteAccount = (ac: domains.IHhrAccount, hhrTitle: domains.IHhrTitle): void => {

            if (!confirm('Account will be deleted. Do you wish to continue?'))
                return;

            if (ac.status === domains.AccountStatus.SETUP) {
                if (ac.id && ac.id > 0) {
                    ac.status = domains.AccountStatus.CANCELED;
                    ac.statusDescription = "WILL BE DELETED";
                    toastr.info("Account has been marked for deleting. Save Work to permanently accept that change");
                } else {
                    var delInd = hhrTitle.accounts.indexOf(ac);
                    if (delInd >= 0) {
                        hhrTitle.accounts.splice(delInd, 1);
                        toastr.info("Account has been deleted");
                    } else {
                        toastr.warning("Account could not be found localy. Refresh page and try again");
                    }
                }
            } else {
                toastr.warning("Account with this status can't be deleted");
            }
        }

        prepareHhrAccountForPost = (ac: domains.IHhrAccount) => {
            if (ac.selRtg) ac.proposedRtgId = ac.selRtg.id; else ac.proposedRtgId = null;
            if (ac.selInvestmentType) ac.investmentType = ac.selInvestmentType.value; else ac.investmentType = null;
            if (ac.selTamp) ac.tampId = ac.selTamp.id; else ac.tampId = null;
            if (ac.selProductType) ac.productType = ac.selProductType.value; else ac.productType = null;
            if (ac.selManager) ac.managerId = ac.selManager.id; else ac.managerId = null;
            if (ac.selProduct) ac.productId = ac.selProduct.id; else ac.productId = null;
        }

        prepareHhrModelForPost = () => {
            for (var g = 0; g < this.hhrModel.groups.length; g++) {
                for (var i = 0; i < this.hhrModel.groups[g].titles.length; i++) {
                    var title = this.hhrModel.groups[g].titles[i];
                    for (var j = 0; j < title.accounts.length; j++) {
                        this.prepareHhrAccountForPost(title.accounts[j]);
                        // var ac = title.accounts[j];
                        // if (ac.selInvestmentType) ac.investmentType = ac.selInvestmentType.value; else ac.investmentType = null;
                        // if (ac.selTamp) ac.tampId = ac.selTamp.id; else ac.tampId = null;
                        // if (ac.selProductType) ac.productType = ac.selProductType.value; else ac.productType = null;
                        // if (ac.selManager) ac.managerId = ac.selManager.id; else ac.managerId = null;
                        // if (ac.selProduct) ac.productId = ac.selProduct.id; else ac.productId = null;
                    }
                }
            }
        }

        saveWork = (): void => {

            this.prepareHhrModelForPost();

            this.advisorHhrService.saveHhrAccounts(this.hhrModel)
                .then(response => {
                    this.hhrModel = response.data;
                    toastr.info("Work saved");
                    this.refreshHouseholdGird();
                }, err => this.generalService.showError(err));
        };

        commitWork = (): void => {

            this.prepareHhrModelForPost();

            this.advisorHhrService.commitHhrAccounts(this.hhrModel)
                .then(response => {
                    toastr.info("Work commited");
                }, err => this.generalService.showError(err));
        };




        // overrides ...
        $onInit(): void {
            this.generalService.getLOVs().then(data => {
                this.investmentTypes = data.filter(f => f.lovType == domains.LovType.ACCOUNT_TYPE);
                this.productTypes = data.filter(f => (f.lovType == domains.LovType.PRODUCT_TYPE));
            });
        };

        $routerOnActivate(next, previous) {
            if (next.params.householdId > 0) {
                this.householdId = next.params.householdId;
                this.loadHousehold(this.householdId);
                this.loadRtgs(this.householdId);
            } else {
                this.loadHouseholds();
            }
        };

        hasProductType = (ac: domains.IHhrAccount): boolean => {
            if (!ac || !ac.selInvestmentType) return false;
            return this.accountGeneralService.hasProductType(ac.selInvestmentType.value);
        }

        hasManager = (ac: domains.IHhrAccount): number => {
            if (!ac || !ac.selInvestmentType) return 0;
            return this.accountGeneralService.hasManager(ac.selInvestmentType.value);
        }

        hasTamp = (ac: domains.IHhrAccount): boolean => {
            if (!ac || !ac.selInvestmentType) return false;
            return this.accountGeneralService.hasTamp(ac.selInvestmentType.value);
        }

        hasProduct = (ac: domains.IHhrAccount): number => {
            if (!ac || !ac.selInvestmentType) return 0;
            var rez = this.accountGeneralService.hasManager(ac.selInvestmentType.value);
            if (rez === 1)
                return ac.selManager ? 1 : 0; //show drop down only if manager has been selected
            else
                return rez;
        }

        hasProposal = (hhrAcc: domains.IHhrAccount): boolean => {
            return hhrAcc && this.accountGeneralService.hasProposal(hhrAcc.investmentType);
        }

        hasRtg = (hhrAcc: domains.IHhrAccount): boolean => {
            return hhrAcc && this.accountGeneralService.hasRtg(hhrAcc.investmentType, false);
        }
        
        openNewTitlePopup = function (): any {
            const $ctrl = this as HhReallocationController;
            var modalInstance = this.$uibModal.open({
                animation: true,
                component: "popHhrNewTitle",
                // size: "sm",
                controllerAs: "vvm",
                bindToController: true,
                resolve: {
                    advisoryFirm: function () {
                        return $ctrl.household.advisoryFirm;
                    },
                    household: function () {
                        return $ctrl.household;
                    },
                },
            });
            
            modalInstance.result.then(
                function (data: domains.IAccount) { // close 

                    var newTitleAcc = $ctrl.mapAccountToHhrAccount(data);

                    var newGroup = <domains.IHhrGroup>{
                        groupId: 0,
                        groupName: 'Not defined',
                        titles: []
                    }

                    var newTitle = <domains.IHhrTitle>{
                        accounts: [newTitleAcc],
                        balance: 0,
                        change: 0,
                        investors: "investors not selected",
                        titleType: data.titleType,
                        titleTypeDescription: data.titleTypeDescription,
                    };

                    newGroup.titles.push(newTitle);

                    //console.log("New account: ", data);
                    //console.log("HHR Title: ", newTitle);
                    //console.log("Sample title: ", $ctrl.hhrModel.titles[0]);

                    //console.log("Loading LOVs for new title...");

                    $ctrl.refreshHhrTitle(newTitle);

                    // investment type description
                    if (newTitleAcc.selInvestmentType)
                        newTitleAcc.investmentTypeDescription = newTitleAcc.selInvestmentType.name;

                    // manager name
                    if (newTitleAcc.selManager)
                        newTitleAcc.managerName = newTitleAcc.selManager.name;

                    // investors
                    newTitle.investors = data.investors.map(m => {
                        if (m.investorType === domains.InvestorType.COMPANY)
                            return m.entityName;
                        else
                            return `${m.firstName} ${m.lastName}`
                    }).join(", ");

                    newTitle.hhrInvestors = data.investors.map(m => <domains.IHhrAccountInvestorViewModel>{
                        investorId: m.id
                    });

                    $ctrl.hhrModel.groups.push(newGroup);

                }, function (data) { // dismiss
                    //console.log("Modal callback 2", data);
                }, function (data) { // result promise rejected
                    //console.log("Modal callback 3", data);
                }, function (data) { // opened promise
                    //console.log("Modal callback 4",data );
                }, function (data) { // closed promise
                    //.log("Modal callback 5", data);
                }, function (data) { // rendered promise
                    //console.log("Modal callback 6", data);
                }
            );

            return modalInstance;
        }

        openChangeRTGPopup = function (hhrAccount: domains.IHhrAccount, hhrTitle: domains.IHhrTitle): any {
            const $ctrl = this as HhReallocationController;
            var modalInstance = this.$uibModal.open({
                animation: true,
                component: "popHhrRtg",
                size: "lg",
                controllerAs: "vvm",
                bindToController: true,
                resolve: {
                    household: function () {
                        return $ctrl.household;
                    },
                    account: this.advisorService.getAccount(hhrAccount.accountId)
                        .then(data => {
                            //console.log(`Account ${hhrAccount.accountId} has been loaded`, data.data);
                            return data.data;
                        }, error => this.generalService.showError(error))
                },
            });

            modalInstance.result.then(
                function (data: domains.IAccount) { // close 
                    
                }, function (data) { // dismiss
                    //console.log("Modal callback 2", data);
                }, function (data) { // result promise rejected
                    //console.log("Modal callback 3", data);
                }
            );

            return modalInstance;

        };

        openInvestmentsPopup = function (hhrAccount: domains.IHhrAccount, hhrTitle: domains.IHhrTitle): any {
            const $ctrl = this as HhReallocationController;
            var modalInstance = this.$uibModal.open({
                animation: true,
                component: "popHhrProposal",
                size: "lg",
                controllerAs: "vvm",
                bindToController: true,
                resolve: {
                    household: function () {
                        return $ctrl.household;
                    },
                    account: () => {
                        if (hhrAccount.accountId > 0) {
                            return $ctrl.accountApi.getById(hhrAccount.accountId)
                                .then(data => {
                                    // default proposal should be taken from HhrAccount
                                    data.data.proposal = hhrAccount.proposal;
                                    //console.log(`Account ${hhrAccount.accountId} has been loaded`, data.data);
                                    return data.data;
                                }, error => $ctrl.generalService.showError(error))
                        } else {
                            $ctrl.prepareHhrAccountForPost(hhrAccount);
                            var newacc = $ctrl.mapHhrAccountToAccount(hhrAccount, hhrTitle);
                            newacc.proposal = hhrAccount.proposal;
                            //console.log("Proposal for a new HHR account", newacc);
                            return newacc;
                        }
                    }
                },
            });

            modalInstance.result.then(
                function (data: domains.IAccount) { // close 
                    hhrAccount.proposal = data;
                    //console.log(`Proposal for HhrAccount ${hhrAccount.id} ${hhrAccount.accountName}`, hhrAccount);
                }, function (data) { // dismiss
                    //console.log("Modal callback 2", data);
                }, function (data) { // result promise rejected
                    //console.log("Modal callback 3", data);
                }
            );

            return modalInstance;

        };


        openProposalPopup = function (hhrAccount: domains.IHhrAccount, hhrTitle: domains.IHhrTitle): any {
            const $ctrl = this as HhReallocationController;
            var modalInstance = this.$uibModal.open({
                animation: true,
                component: "popHhrProposal",
                size: "lg",
                controllerAs: "vvm",
                bindToController: true,
                resolve: {
                    household: function () {
                        return $ctrl.household;
                    },
                    account: {}
                },
            });

            modalInstance.result.then(
                function (data: domains.IAccount) { // close 
                   
                }, function (data) { // dismiss
                    //console.log("Modal callback 2", data);
                }, function (data) { // result promise rejected
                    //console.log("Modal callback 3", data);
                }
            );

            return modalInstance;

        };

        mapAccountToHhrAccount(account: domains.IAccount): domains.IHhrAccount {
            const hhrAcc = <domains.IHhrAccount>{
                id: 0,
                accountId: null,
                accountName: account.name,
                advisoryFirmId: account.advisoryFirm.id,
                advisoryFirmType: account.advisoryFirm.firmType,
                balance: 0,
                change: 0,
                status: domains.AccountStatus.SETUP,
                statusDescription: "Setup",
                investors: [], // take it from Title on server side ... ??? // we need to map investors from account
                original: {},
                // company: null,
                investmentType: account.accountType,
                investmentTypeDescription: null,
                managerId: account.managerId,
                managerName: null,
                productType: account.productTypeId,
                productTypeDescription: null,
                productId: account.productId,
                productDescription: account.productDescription,
                productName: null,
                rtgId: null,
                rtgDescription: null,
                titleType: account.titleType,
                titleSubtype: account.titleSubtype,
                tampId: account.tampId,
                tampName: account.tampName,

                tamps: [],
                managers: [],
                products: [],
                selTamp: null,
                selManager: null,
                selProduct: null,
                selProductType: null,
                selInvestmentType: {
                    value: account.accountType,
                    name: account.accountTypeDescription
                },
            };
            
            return hhrAcc;
        }


        mapHhrAccountToAccount(hhrAcc: domains.IHhrAccount, hhrTitle: domains.IHhrTitle): domains.IAccount {
            //console.log("Household: ", this.household);
            //console.log("Sel household: ", this.selHousehold);
            const acc = <domains.IAccount>{
                id: hhrAcc.accountId,
                name: hhrAcc.accountName,
                advisoryFirmId: this.household.advisoryFirmId,
                advisoryFirm: this.household.advisoryFirm,
                status: domains.AccountStatus.SETUP,
                statusDescription: "Setup",
                investors: [],
                accountType: hhrAcc.investmentType,
                accountTypeDescription: hhrAcc.investmentTypeDescription,
                managerId: hhrAcc.managerId,
                advisoryFee: 0,
                productTypeId: hhrAcc.productType,
                productId: hhrAcc.productId,
                productDescription: hhrAcc.productDescription,
                productName: hhrAcc.productName,
                rtgs: [],
                titleType: hhrAcc.titleType,
                titleSubtype: hhrAcc.titleSubtype,
                tampId: hhrAcc.tampId,
                tampName: hhrAcc.tampName,
                company: hhrAcc.company,
                advisoryFirmMgtRole: domains.AdvisoryFirmMgtRole.MANAGED, // this should not be so important
            };

            acc.investors = hhrTitle.hhrInvestors.map(m => {
                return <domains.IInvestor>{
                    id: m.investorId,
                    fullName: m.investorName,
                    firstName: m.investorName
                };
            });

            return acc;
        }

    }

    
    class HhReallocation implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //$canActivate;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = HhReallocationController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/hh-reallocation.html';
            //this.$canActivate = ["advisorService", (advisorService: services.AdvisorService) => {
            //    if (advisorService.isAdminModeEnabled()) {
            //        toastr.info("Please exit from Admin Mode to enable account wizard");
            //        return false;
            //    }
            //    return true;
            //}];
        }
    }
    angular.module(Constants.APP).component("hhReallocation", new HhReallocation());
}